module.exports = __webpack_public_path__ + "img/ic_daily_checkins.93f50779.png";